var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warning"},[_c('img',{attrs:{"src":require("@/images/form/bingeDrinkerWarning/icon-binge-warning.svg"),"alt":""}}),_c('p',[_vm._v(" "+_vm._s(_vm.dictionary[_vm.DictionaryField.DCC_RESULTS_BINGEDRINKWARNING])+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }